import { keepPreviousData } from '@tanstack/react-query'
import { SWAP_QUOTE_REFETCH_POLICY } from 'config/RefetchPolicies'
import { useMemo } from 'react'

import { QuoteQueryParams, useRouteQuote } from './routing'

export function useFetchKxQuote(
  params: QuoteQueryParams | undefined | null,
  options?: {
    skip?: boolean
    pollingInterval?: number
    refetchOnReconnect?: boolean
    refetchOnMountOrArgChange?: boolean
    refetchOnMount?: boolean | 'always'
    refetchInterval?: number | false
    refetchOnWindowFocus?: boolean
    retry?: number | boolean
    gcTime?: number
    staleTime?: number
  }
) {
  const query = useRouteQuote(params ?? {}, {
    skip: options?.skip || !params,
    refetchInterval: options?.pollingInterval ?? options?.refetchInterval ?? SWAP_QUOTE_REFETCH_POLICY.refetchInterval,
    refetchOnReconnect: options?.refetchOnReconnect ?? SWAP_QUOTE_REFETCH_POLICY.refetchOnReconnect,
    refetchOnWindowFocus: options?.refetchOnWindowFocus ?? SWAP_QUOTE_REFETCH_POLICY.refetchOnWindowFocus,
    refetchOnMount: options?.refetchOnMount ?? options?.refetchOnMountOrArgChange,
    retry: options?.retry ?? SWAP_QUOTE_REFETCH_POLICY.retry,
    gcTime: options?.gcTime ?? SWAP_QUOTE_REFETCH_POLICY.gcTime,
    staleTime: options?.staleTime ?? SWAP_QUOTE_REFETCH_POLICY.staleTime,
    placeholderData: keepPreviousData,
  })

  return useMemo(() => {
    const error = query.error as (Error & { status?: number; data?: any }) | null | undefined

    const normalizedError = error
      ? {
          status: error.status ?? 500,
          data: error.data ?? null,
          error: error.message,
        }
      : undefined

    return {
      data: query.data,
      isLoading: query.isLoading,
      isFetching: query.isFetching,
      isError: query.isError,
      error: normalizedError,
      refetch: query.refetch,
    }
  }, [query])
}
